import { GridColDef, GridRenderCellParams, GridTreeNodeWithRender, GridValidRowModel } from "@mui/x-data-grid-premium";
import { format, parseISO } from "date-fns";
import { useIntl } from "react-intl";

import { ContractEventType, IEventHistory, type IExchangeLendEvent } from "@framework/types";
import { TxHashLink } from "@dzambalaorg/mui-scanner";
import { humanReadableDateTimeFormat } from "@dzambalaorg/constants";

export const transactionsColumnsCreator = (
  formatMessage: ReturnType<typeof useIntl>["formatMessage"],
  account?: `0x${string}`,
): GridColDef<GridValidRowModel>[] => [
  {
    field: "id",
    headerName: formatMessage({ id: "form.labels.id" }),
    sortable: false,
    flex: 1,
    minWidth: 100,
  },
  {
    field: "eventType",
    headerName: formatMessage({ id: "form.labels.eventType" }),
    sortable: true,
    flex: 2,
    renderCell: (params: GridRenderCellParams<GridValidRowModel, any, IEventHistory, any>) => {
      const { eventData, eventType } = params.row;
      const isBorrow = eventType === ContractEventType.Lend && account !== (eventData as IExchangeLendEvent).account;
      return <>{isBorrow ? formatMessage({ id: "enums.eventDataLabel.borrow" }) : eventType}</>;
    },
    minWidth: 140,
  },
  {
    field: "createdAt",
    headerName: formatMessage({ id: "form.labels.date" }),
    sortable: true,
    valueFormatter: (value: string) => format(parseISO(value), humanReadableDateTimeFormat),
    flex: 1.2,
    minWidth: 160,
  },
  {
    field: "transactionHash",
    headerName: formatMessage({ id: "form.labels.tx" }),
    sortable: false,
    renderCell: (params: GridRenderCellParams<GridValidRowModel, string, IEventHistory, GridTreeNodeWithRender>) => {
      return <TxHashLink hash={params.value!} />;
    },
    flex: 1,
    minWidth: 180,
  },
];
